import {useEffect, useState} from 'react';
import {useLazyQuery} from '@apollo/react-hooks';
import {validacion, defaults, dev} from 'lib.common';

const {esVarNullUndef} = validacion;
const {funcionVacia} = defaults;

export default function useApolloLazyQ(
   query,
   {
      callbackProcesarData = funcionVacia,
      callbackError = funcionVacia,
      callbackLoading = funcionVacia
   } = {},
   apolloOptions = {}
) {
   const [dsVariables, setDsVariables] = useState(null);
   function onCompleted(data) {
      if (!esVarNullUndef(data)) {
         callbackProcesarData(data, dsVariables);
      }
      setDsVariables(null);
   }

   function onError(error) {
      let eMsg = '';
      if (!esVarNullUndef(error)) {
         eMsg = eMsg + dev.getErrorMsg(error);
      }
      if (eMsg !== '') {
         callbackError(eMsg);
      }
      setDsVariables(null);
   }

   const [fetchDataApollo, {data, loading, called, error, ...apolloResult}] = useLazyQuery(query, {
      ...apolloOptions,
      onCompleted,
      onError
   });
   async function fetchData(apolloProps, extraData = null) {
      setDsVariables(extraData);
      return fetchDataApollo(apolloProps);
   }

   useEffect(() => {
      callbackLoading(loading);
   }, [loading]);

   return [fetchData, {data, loading, called, error, ...apolloResult}];
}
